import { I18nService } from '@/core/services/i18nService';
import { PaymentDisplayModel, AnfrageDisplayModel, PaymentFoerdersummenDisplayModel, GlobalEnumerationsAceMittelabruf, LocalizedTextDisplayModel, PortalkonfigurationDisplayModel } from '@/api/model-index';
import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, inject, ViewChild, OnDestroy, Type } from '@angular/core';
import { NavigationItem } from '@/core/models/navigation-item.model';
import { NavigationService } from '@/core/services/navigation.service';
import { PaymentService } from '@/core/services/payment.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { StateService } from '@/core/services/state.service';
import { DraggableSidebarService } from '@/core/services/draggable-sidebar.service';
import { ComponentService } from '@/core/services/component.service';
import { AnfrageLiveSharingComponent } from '@/core/features/anfrage/components/anfrage-live-sharing/anfrage-live-sharing.component';
import { DetailSidepaneComponent } from '@/core/components/detail-sidepane/detail-sidepane.component';

@Component({
  selector: 'app-funding-detail',
  templateUrl: './funding-detail.component.html',
  styleUrls: ['./funding-detail.component.scss'],
  standalone: false
})
export class FundingDetailComponent implements OnDestroy {
  public anfrage: AnfrageDisplayModel;
  public fundingAmounts: PaymentFoerdersummenDisplayModel;
  public portalkonfiguration: PortalkonfigurationDisplayModel;
  public navItem: NavigationItem | null;
  public type: GlobalEnumerationsAceMittelabruf = GlobalEnumerationsAceMittelabruf.Forderbetrag;
  public portalContextService: PortalContextService = inject(PortalContextService);
  public stateService: StateService = inject(StateService);
  protected draggableSidebar = inject(DraggableSidebarService);
  protected componentService: ComponentService = inject(ComponentService);

  public get showProzessNavigation() {
    return this.stateService.showProzessNavigation;
  }

  constructor(
    protected route: ActivatedRoute,
    protected languageservice: I18nService,
    protected navigationService: NavigationService,
    protected paymentService: PaymentService
  ) {

    this.anfrage = this.portalContextService.CurrentAnfrage;
    this.fundingAmounts = this.route.snapshot.data.fundingAmounts;
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;

    if (this.portalkonfiguration.mittelabrufAbschnitt) {
      this.navItem = this.navigationService.getNavItem(this.portalkonfiguration.mittelabrufAbschnitt)
      if (this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Zahlung)
        this.navItem!.link += "/funding-amount";
      else if (this.portalkonfiguration.artDesMittelabrufs == GlobalEnumerationsAceMittelabruf.Forderbetrag)
        this.navItem!.link += "/payment";
    }
  }

  protected nullReference: AnfrageDisplayModel;
  ngOnDestroy(): void {
    this.portalContextService.CurrentAnfrage = this.nullReference;
  }

  onAppNavigationItemClick(): void {
    if (window.innerWidth < 1024) {
      this.stateService.showProzessNavigation = false;
    }
  }

  get anfrageLiveSharingComponent(): any {
    return this.componentService.get(AnfrageLiveSharingComponent);
  }

  public get detailSidepaneComponent(): Type<DetailSidepaneComponent> {
    return this.componentService.get(DetailSidepaneComponent);
  }
}
